export default __webpack_public_path__ + "static/media/icon-instagram.e18458ff.svg";